import { inject } from '@angular/core';
import { MapInteractionsService } from '../../services/mapInteractions.service';
import { PanCommand } from './pan.command';

/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export function panFactory() {
    const command = new PanCommand();
    command.setDependencies({
        interactions: inject(MapInteractionsService),
    });
    return command;
}